import React from 'react';
import { Box, Typography } from '@mui/material';

// Standard footer for printed reports & receipts. Subtle, print-friendly, and
// consistent across documents. Pass an optional `note` (e.g. a thank-you or
// "system-generated" line) shown above the product credit.
const YEAR = new Date().getFullYear();

const ReportFooter = ({ note }) => (
  <Box sx={{ mt: 4, pt: 1.5, borderTop: '1px solid #e0e0e0', textAlign: 'center' }}>
    {note && (
      <Typography variant="caption" display="block" color="text.secondary" sx={{ mb: 0.5 }}>
        {note}
      </Typography>
    )}
    <Typography variant="caption" display="block" sx={{ color: '#607d8b', fontWeight: 600, letterSpacing: 0.3 }}>
      Powered by EduMIS — Dataport Technologies
    </Typography>
    <Typography variant="caption" display="block" sx={{ color: '#90a4ae' }}>
      Smart systems for modern schools · © {YEAR}
    </Typography>
  </Box>
);

export default ReportFooter;
